module.exports = __webpack_public_path__ + "img/project-01-02.39cc07c3.png";